export default __webpack_public_path__ + "static/media/noImage.030a3ffd.png";